import { render, staticRenderFns } from "./FilterPagination.vue?vue&type=template&id=51811af7"
import script from "./FilterPagination.vue?vue&type=script&lang=ts"
export * from "./FilterPagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports